import { Injectable } from '@angular/core';
import { StorageEngine } from '@ngxs/storage-plugin';
import { getStoreScopedKey } from './happy-store-scope.util';

@Injectable()
export class HappyStoreLocalStorageEngine implements StorageEngine {
  getItem(key: string): any {
    try {
      return window.localStorage.getItem(getStoreScopedKey(key));
    } catch {
      return null;
    }
  }

  setItem(key: string, value: any): void {
    try {
      window.localStorage.setItem(getStoreScopedKey(key), value);
    } catch {
      // Ignore storage failures.
    }
  }
}
